/* eslint-disable import/first */
// shared css require needs to come first so component css can override shared css without needing !important
require('@alltrails/shared/sharedCss.css');

import { DescriptionHolder } from 'react_components/feeds/description_holder';
import { lazy } from 'react';
import FooterWrapper from 'components/FooterWrapper';
import GlobalActions from 'components/GlobalActions';
import ListActionBar from 'components/ListActionBar';
import NavBar from 'components/NavBar';
import StarRatingAndReviews from 'components/shared/StarRatingAndReviews';
import ViewMapButton from 'components/shared/ViewMapButton/ViewMapButton';
import TrailUgcWrapper from 'components/trailUgc/TrailUgcWrapper';
import withSuspense from '../hocs/withSuspense';

// import css in your controller using @css = 'trail-page-css'
const SidebarTrailResultListWrapper = lazy(() => import('components/SidebarTrailResultListWrapper'));
const ReportAnIssueWrapper = lazy(() => import('components/ReportAnIssueWrapper'));

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ReactRailsUJS = require('react_ujs');

const context = {
  DescriptionHolder,
  FooterWrapper,
  GlobalActions,
  ListActionBar,
  NavBar,
  SidebarTrailResultListWrapper: withSuspense(SidebarTrailResultListWrapper, 'SidebarTrailResultListWrapper'),
  StarRatingAndReviews,
  TrailUgcWrapper,
  ViewMapButton,
  ReportAnIssueWrapper: withSuspense(ReportAnIssueWrapper, 'ReportAnIssueWrapper')
};

ReactRailsUJS.getConstructor = className => context[className];
